import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppGuard } from "../app.authguard";
import { ContaAppComponent } from "./conta.app.component";
import { GerenciamentoComponent } from "./gerenciamento/gerenciamento.component";
import { LoginComponent } from "./login/login.component";

const contaRouterConfig: Routes = [
    {
        path: '', component: ContaAppComponent,
        children: [
            {
                path: 'gerenciamento',
                component: GerenciamentoComponent,
                canActivate: [AppGuard],
                canLoad: [AppGuard],
            },
            { path: 'login', component: LoginComponent }
        ]
    }
];
@NgModule({
    imports: [
        RouterModule.forChild(contaRouterConfig)
    ],
    exports: [
        RouterModule
    ]
})
export class ContaRoutingModule { }